// extracted by mini-css-extract-plugin
export default {"centered":"NotFound_centered__M3rfg"};